"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FraktMarketState = exports.NftValidationWhitelistType = void 0;
var NftValidationWhitelistType;
(function (NftValidationWhitelistType) {
    NftValidationWhitelistType["Creator"] = "creator";
    NftValidationWhitelistType["Nft"] = "nft";
    NftValidationWhitelistType["MerkleTree"] = "merkleTree";
    NftValidationWhitelistType["CollectionId"] = "collectionId";
})(NftValidationWhitelistType = exports.NftValidationWhitelistType || (exports.NftValidationWhitelistType = {}));
var FraktMarketState;
(function (FraktMarketState) {
    FraktMarketState["Initialized"] = "initialized";
    FraktMarketState["Active"] = "active";
})(FraktMarketState = exports.FraktMarketState || (exports.FraktMarketState = {}));
